import {
    LOADING_TOGGLE_ACTION,
    LOGIN_CONFIRMED_ACTION,
    LOGIN_FAILED_ACTION,
    LOGOUT_ACTION,
    SIGNUP_CONFIRMED_ACTION,
    SIGNUP_FAILED_ACTION,
} from './actions/authActionTypes';

const NAVTOGGLE = 'NAVTOGGLE';
const NAV_OPEN = 'NAV_OPEN';
const NAV_CLOSE = 'NAV_CLOSE';

const CREATE_POST_ACTION = '[Post Action] Create Post';
const CONFIRMED_CREATE_POST_ACTION = '[Post Action] Confirmed Create Post';
const CONFIRMED_GET_POSTS = '[Post Action] Confirmed Get Posts';
const CONFIRMED_EDIT_POST_ACTION = '[Post Action] Confirmed Edit Post';
const CONFIRMED_DELETE_POST_ACTION = '[Post Action] Confirmed Delete Post';

const authInitialState = {
    auth: {
        accessToken: '',
        expiresAt: '',
        expireDate: '',
        user: null,
    },
    errorMessage: '',
    successMessage: '',
    showLoading: false,
};

export function authLegacyReducer(state = authInitialState, action) {
    if (action.type === SIGNUP_CONFIRMED_ACTION) {
        return {
            ...state,
            auth: action.payload,
            errorMessage: '',
            successMessage: 'Signup Successfully Completed',
            showLoading: false,
        };
    }
    if (action.type === LOGIN_CONFIRMED_ACTION) {
        return {
            ...state,
            auth: action.payload,
            errorMessage: '',
            successMessage: 'Login Successfully Completed',
            showLoading: false,
        };
    }
    if (action.type === LOGOUT_ACTION) {
        return {
            ...state,
            errorMessage: '',
            successMessage: '',
            auth: {
                accessToken: '',
                expiresAt: '',
                expireDate: '',
                user: null,
            },
        };
    }
    if (action.type === SIGNUP_FAILED_ACTION || action.type === LOGIN_FAILED_ACTION) {
        return {
            ...state,
            errorMessage: action.payload,
            successMessage: '',
            showLoading: false,
        };
    }
    if (action.type === LOADING_TOGGLE_ACTION) {
        return {
            ...state,
            showLoading: action.payload,
        };
    }
    return state;
}

const postsInitialState = { posts: [] };
export function postsLegacyReducer(state = postsInitialState, action) {
    if (action.type === CREATE_POST_ACTION) {
        const post = {
            id: Math.random(),
            title: 'Post Title 2asdasd',
            description: 'Sample Description 2asdasdas',
        };
        return { ...state, posts: [...state.posts, post] };
    }
    if (action.type === CONFIRMED_DELETE_POST_ACTION) {
        return {
            ...state,
            posts: state.posts.filter((post) => post.id !== action.payload),
        };
    }
    if (action.type === CONFIRMED_EDIT_POST_ACTION) {
        const posts = [...state.posts];
        const idx = posts.findIndex((post) => post.id === action.payload.id);
        if (idx >= 0) posts[idx] = action.payload;
        return { ...state, posts };
    }
    if (action.type === CONFIRMED_CREATE_POST_ACTION) {
        return { ...state, posts: [...state.posts, action.payload] };
    }
    if (action.type === CONFIRMED_GET_POSTS) {
        return { ...state, posts: action.payload };
    }
    return state;
}

export function sideMenuLegacyReducer(state = false, action) {
    if (action.type === NAVTOGGLE) return !state;
    if (action.type === NAV_OPEN) return true;
    if (action.type === NAV_CLOSE) return false;
    return state;
}

const todoInitialState = { list: [] };
export function todoLegacyReducer(state = todoInitialState, action) {
    switch (action.type) {
        case 'ADD_TODO': {
            const { id, data } = action.payload;
            return { ...state, list: [...state.list, { id, data }] };
        }
        case 'DELETE_TODO':
            return { ...state, list: state.list.filter((elem) => elem.id !== action.id) };
        case 'REMOVE_TODO':
            return { ...state, list: [] };
        default:
            return state;
    }
}
